export default ({ request }) => ({
  custInfoListApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/list',
      method: 'post',
      data,
    })
  },
  custInfoDetailApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/detail',
      method: 'post',
      data,
    })
  },
  custInfoSaveApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/save',
      method: 'post',
      data,
    })
  },
  custInfoDelApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/del',
      method: 'post',
      data,
    })
  },
  custInfoDevelopApplyApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/autoAudit',
      method: 'post',
      data,
    })
  },
  masterCustomerOaAddAuditApi(data = {}) {
    return request({
      url: '/oa/master/customer/addAudit',
      method: 'post',
      data,
    })
  },
  masterCustomerInformationApplyApi(data = {}) {
    return request({
      url: '/oa/master/customer/information/apply',
      method: 'post',
      data,
    })
  },
  masterCustomerApplyApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/apply',
      method: 'post',
      data,
    })
  },
  masterCustomerRollbackApplyApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/rollback/apply',
      method: 'post',
      data,
    })
  },
  masterCustomerV2DetailApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/v2/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerChangeLogoApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/changeLogo',
      method: 'post',
      data,
    })
  },
  masterCustomerContactsListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/contacts/list',
      method: 'post',
      data,
    })
  },
  masterCustomerContactsSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/contacts/save',
      method: 'post',
      data,
    })
  },
  masterCustomerContactsDelApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/contacts/del',
      method: 'post',
      data,
    })
  },
  masterCustomerBankListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/bank/list',
      method: 'post',
      data,
    })
  },
  masterCustomerBankDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/bank/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerBankDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/bank/del',
      method: 'post',
      data,
    })
  },
  masterCustomerBankSaveApi(data) {
    return request({
      url: '/digitalCenter/master/customer/bank/save',
      method: 'post',
      data,
    })
  },
  masterCustomerTakeOrderListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/take/order/list',
      method: 'post',
      data,
    })
  },
  masterCustomerTakeOrderSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/take/order/save',
      method: 'post',
      data,
    })
  },
  masterCustomerTakeOrderDelApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/take/order/del',
      method: 'post',
      data,
    })
  },
  masterCustomerUserPerformanceApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/user/performance',
      method: 'post',
      data,
    })
  },
  masterCustomerConvertPotentialApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/convertPotential',
      method: 'post',
      data,
    })
  },
  masterCustomerConvertFormalApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/convertFormal',
      method: 'post',
      data,
    })
  },
  masterCustomerInfoChangeApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/infoChange',
      method: 'post',
      data,
    })
  },
  masterCustomerOrderChangeApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/orderChange',
      method: 'post',
      data,
    })
  },
  masterCustomerBankChangeApi(data = {}) {
    return request({
      url: '/digitalCenter/masterCustomer/bankChange',
      method: 'post',
      data,
    })
  },
})
